// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/policy/mondoo_policy.actions.go

import { type Scope } from "~/hooks/useScope";
import { REFRESH_AGGREGATE_SCORES } from "./action";

export function canRefreshAggregateScores(scope: Scope): boolean {
  return scope.iamActions.includes(REFRESH_AGGREGATE_SCORES);
}
